import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';

interface EnvironmentVariables {
  SUPPLIERS_PUBLIC_KEY: string;
}

@Injectable()
export class ConfigService {
  public static settings: any;

  constructor(private http: HttpClient) {}

  public async load() {
    const configFile = await this.getConfigFile();
    const environmentVariables = await this.getEnvironmentVariables();

    ConfigService.settings = { ...configFile, env: environmentVariables };
  }

  private async getConfigFile(): Promise<JSON> {
    try {
      return await lastValueFrom(this.http.get<JSON>('assets/config/config.json'));
    } catch (error: any) {
      console.log(`Could not load config file: ${error.statusText}`);
    }

    return JSON.parse('{}');
  }

  private async getEnvironmentVariables(): Promise<EnvironmentVariables> {
    try {
      return await lastValueFrom(this.http.get<EnvironmentVariables>('/api/payment-contracts/client/environment'));
    } catch (error: any) {
      console.log(`Could not load environment variables: ${error.statusText}`);
    }

    return JSON.parse('{}');
  }
}
